module.exports = __webpack_public_path__ + "static/media/product-icon.4b3722e2.png";